const PUBLIC_KEY_PEM = process.env.REACT_APP_RSA_PUBLIC_KEY;

async function importPublicKey(pem) {
    const pemContent = pem
        .replace(/\\n/g, "\n")
        .replace("-----BEGIN PUBLIC KEY-----", "")
        .replace("-----END PUBLIC KEY-----", "")
        .replace(/\s/g, "");

    const binaryDer = atob(pemContent);
    const binaryArray = new Uint8Array(binaryDer.length);
    for (let i = 0; i < binaryDer.length; i++) {
        binaryArray[i] = binaryDer.charCodeAt(i);
    }

    return crypto.subtle.importKey(
        "spki",
        binaryArray.buffer,
        { name: "RSA-OAEP", hash: "SHA-256" },
        false,
        ["encrypt"]
    );
}

/**
 * Kriptira lozinku RSA-OAEP javnim ključem.
 * Ako ključ nije konfiguriran, vraća lozinku neizmijenjenu (dev fallback).
 */
export async function encryptPassword(password) {
    if (!PUBLIC_KEY_PEM) return password;

    const publicKey = await importPublicKey(PUBLIC_KEY_PEM);
    const encoded = new TextEncoder().encode(password);
    const encrypted = await crypto.subtle.encrypt(
        { name: "RSA-OAEP" },
        publicKey,
        encoded
    );

    const bytes = new Uint8Array(encrypted);
    let binary = "";
    for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
